export default function Services() {
  const services = [
    {
      title: 'Exame Completo',
      description: 'Tecnologia de ponta para diagnóstico preciso da sua visão',
      image: 'https://public.readdy.ai/ai/img_res/c96aab8c40ee003164ed583a40627b60.jpg'
    },
    {
      title: 'Ajustes Gratuitos',
      description: 'Ajustamos suas armações para o conforto perfeito',
      image: 'https://readdy.ai/api/search-image?query=professional%20hands%20adjusting%20eyeglass%20frames%20close-up%20detailed%20craftsmanship%20optical%20service%20precision%20work%20clean%20background%20quality%20care%20attention%20to%20detail%20professional%20service&width=600&height=600&seq=service-adjustments&orientation=squarish'
    },
    {
      title: 'Garantia Estendida',
      description: 'Proteção completa para seus óculos por até 2 anos',
      image: 'https://readdy.ai/api/search-image?query=premium%20eyeglasses%20with%20protective%20case%20elegant%20presentation%20luxury%20optical%20products%20quality%20assurance%20professional%20care%20clean%20modern%20aesthetic%20trust%20and%20reliability%20high-end%20service%20optical%20store%20display%20sophisticated%20arrangement&width=700&height=600&seq=service-warranty-new&orientation=landscape'
    }
  ];

  return (
    <section id="servicos" className="py-16 md:py-32 px-6 md:px-20 bg-gray-50">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-3xl md:text-6xl font-bold text-gray-900 text-center mb-10 md:mb-16">
          Cuidado completo para sua visão 👁️
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {services.map((service, index) => (
            <div 
              key={index}
              className="relative rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer group"
              style={{ height: '400px' }}
            >
              <div className="absolute inset-0">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/90 via-gray-900/50 to-transparent"></div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <h3 className="text-white text-2xl md:text-3xl font-bold mb-2 md:mb-3">{service.title}</h3>
                <p className="text-white text-sm md:text-base leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}